import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { EventDelegatorService } from '@services/event-delegator.service';
import { CookiesService } from './cookies.service';
import { GlobalDataService } from '@services/global-data.service';
import { filter } from 'rxjs/operators';
import { ConfirmationDialogComponent } from '@dialogs/confirmation-dialog/confirmation-dialog.component';

const pageTitle = {
  '': 'Dashboard',
  mattermaps: 'Analyze',
  login: 'Login',
  invited: 'Invite Register',
  error: 'Session expired',
  resetPassword: 'Reset Password',
  dashboard: 'Dashboard',
  linker: 'Linker',
  manage: 'Manage Admin',
  data: 'Data Sources',
  insights: 'Insights',
  explorer: 'Explorer',
  request: 'Request',
  mcda: 'MCDA',
  reports: 'Reports History',
  screenshot: 'Screenshot Script',
  report: 'Report',
  advanced_importer: 'Advanced Importer',
  profile: 'My Profile',
  discussions: 'Discussion',
  composer: 'Composer',
  trash: 'Trash',
  'data-explorer': 'Data Explorer',
  'my-site': 'My Site',
  'information-requests': 'Information Requests',
  'styleguide-v9': 'Styleguide-v9',
  'compliance-audit': 'Compliance Audit',
  'data-manager': 'Data Manager',
  'job-request': 'Job Request',
  'billing-app': 'Billing Application',
  'lookup-tool': 'Advance Search',
  'data-statistics': 'Data Statistics',
  'pdf-viewer': 'Pdf Viewer',
  'to-do': 'To-do',
  'pef-analysis': 'PEF Analysis',
  'epd-dashboard': 'EPD Dashboard',
  'cbam-dashboard': 'CBAM Dashboard',
  'data-collection': 'Data Collection Campaigns',
  'ihm-eu-dashboard': 'IHM EU Dashboard'
};

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  currentUrl: string;
  previousUrl: string;
  token = localStorage.getItem('auth_token');
  cookieCheckTimer: any;
  constructor(
    private router: Router,
    private globalDataService: GlobalDataService,
    private dialog: MatDialog,
    private eventDelegatorService: EventDelegatorService,
    private titleService: Title,
    private cookiesService: CookiesService
  ) {
    this.currentUrl = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.locationChangeStart(event);
        this.stateChangeStart(event);
        // Avoid multiple Cookie Acceptance Banner in case of redirects
        if (this.cookieCheckTimer) clearTimeout(this.cookieCheckTimer);
        this.cookieCheckTimer = setTimeout(() => {
          this.cookiesService.checkCookiesAccepted();
        }, 100);
      }
    });
  }

  locationChangeStart(event) {
    this.previousUrl = this.currentUrl;
    this.currentUrl = event.url;
    const locationChange = {
      previous: this.previousUrl,
      current: this.currentUrl
    };
    this.globalDataService.setLocationChange(locationChange);
  }

  stateChangeStart(event) {
    // check for url other than
    // */login* */error* */invited?token* */resetPassword*
    if (!/(\/login|\/error|\/invited\?token|\/resetPassword)/.test(event.url)) {
      if (!localStorage.getItem('auth_token') && !localStorage.getItem('refresh_token')) {
        this.globalDataService.setTokenString(null);
        if (window.location.pathname) {
          //* this is not working, */
          //* it was an old feature that seems broken now */
          this.router.navigate(['login'], { queryParams: { next: window.location.pathname.replace('/', '') } });
        } else {
          this.router.navigate(['login']);
        }
      } else {
        const t = localStorage.getItem('auth_token');
        this.token = t;
        this.globalDataService.setTokenString(t);
      }
    }

    if (this.globalDataService.getFeatureArray() === undefined && localStorage.getItem('user_info')) {
      const info = JSON.parse(localStorage.getItem('user_info'));

      if (info) {
        this.globalDataService.setFeatures();
      }
    }

    this.previousUrl = this.currentUrl;
    this.currentUrl = event.url;

    if (!this.token) {
      return;
    }

    if (['/login', '/invited?token', '/resetPassword'].includes(this.currentUrl)) {
      const tokenString = this.globalDataService.getTokenString();
      if (tokenString) {
        this.router.navigate(['/dashboard']);
      }
    } else {
      let resetFilter = true;
      if (this.currentUrl === this.previousUrl) {
        resetFilter = false;
      }
    }
  }

  onChangeRoute() {
    // this will be triggered whenever change in route navigation
    // No need to unsubscribe route because it produce single instance
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      let key = location.pathname.split('/')[1];
      key = key || '';
      const title = pageTitle[key];
      this.setPageTitle(title);
    });
  }

  setPageTitle(title: string) {
    let appTitle = 'Makersite app';
    if (title) {
      appTitle = `${title} | ${appTitle}`;
    }
    this.titleService.setTitle(appTitle);
  }
}
